type Subscription<S> = (state?: S) => void;

export interface ISignalService<S, DT> {
  subscribe: (signal: S, handler: (data?: DT) => void, targetId?: string | undefined) => () => void;
  unsubscribe: (signal: S, handler: (data?: DT) => void, targetId?: string | undefined) => void;
  send: (signal: S, data?: DT, targetId?: string | undefined) => void;
}

/**
 * Presentation Logic Controller (Ploc)
 */
export abstract class Ploc<S> {
  private internalState: S;
  private signalService: ISignalService<string, S>;

  constructor(initialState: S, signalService: ISignalService<string, S>) {
    this.internalState = initialState;
    this.signalService = signalService;
  }

  public get state(): S {
    return this.internalState;
  }

  changeState(state: S) {
    this.internalState = state;
    this.signalService.send("grid-state-change", this.internalState);
  }

  subscribe(listener: Subscription<S>): () => void {
    return this.signalService.subscribe("grid-state-change", listener);
  }

  unsubscribe(listener: Subscription<S>) {
    this.signalService.unsubscribe("grid-state-change", listener);
  }

  dispose() {
    // Assuming SignalServiceBase handles unsubscription, no need for additional cleanup
  }

  protected assignState(props: Partial<S>) {
    this.changeState({ ...this.state, ...props });
  }
}
